// extracted by mini-css-extract-plugin
export default {"fakeCheckbox":"P4hyoYfVpZBOtc_pmxib","fakeCheckboxImg":"dvVF9VUsXirK4lrNCCem","animatedChecklist":"Y4G5pwRHArmg1HINsJmO","replayButton":"fdnsoxI8ph7D0Cj3TRos"};